// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"5131017a","182":"d6cd6a74","452":"fccf044c","453":"96453769","481":"82473ac2","556":"b762b249","676":"50fd026c","715":"98892661"}[chunkId] + ".chunk.js";
};